import { useCallback } from 'react';
import { useLogout } from '@core/js/hooks/auth/hooks/useLogout';
import { useDeviceSelector } from '@core/js/store/hooks';
import { prop } from 'ramda';
import { useSmartClosePopups } from '@core/js/components/common/PopupManager';

export const useHandleLogoutNotification = () => {
    const logout = useLogout();
    const isDesktop = useDeviceSelector(prop('isDesktop'));
    const closePopups = useSmartClosePopups();

    return useCallback(async (): Promise<void> => {
        await logout({ isQuiet: true, isManual: false });
        closePopups('logout');

        if (!isDesktop) {
            window.Playtech.API.menu.closeSlideMenu();
        }

    }, [logout, closePopups, isDesktop]);
};
